import React from 'react'
import GameLiveScore from './gameLiveScore.jsx'
import {store} from '../football_stats.jsx';

/**
 * Compares 2 stats and sorts players by them
 * @param a
 * @param b
 * @return int
 */
function compareByDate(a, b)
{
    let gameA = a;
    let gameB = b;

    //Sorting games by stage if needed...
    if((gameA.stage == 'ChampionshipRound' || gameA.stage == 'RelegationRound') && gameB.stage == 'RegularSeason') {
        return -1;
    } else if(gameA.stage == 'RegularSeason' && (gameB.stage == 'RelegationRound' || gameB.stage == 'ChampionshipRound')) {
        return 1;
    }

    if(gameA.date.sec > gameB.date.sec) {
        return 1
    } else if (gameA.date.sec < gameB.date.sec) {
        return -1;
    } else {
        return 0;
    }
}

const liveGamesWidget = ({
    rounds,
    currentRound,
    gamesStage,
    currentSlideIndex,
    isRelegation
}) =>  {

    let liveRoundsGames = [];
    let itemsCount = is_mobile ? (gamesStage == 'playoff' ? 1 : 2) : gamesStage == 'playoff' ? (isRelegation ? 4 : 3) : 7; //TODO: support playoff (move by 1 for each side)
    let numofGamesInRound = gamesStage == 'playoff' ? (isRelegation ? 4 : 3) : 7;

    if(Object.keys(rounds).length) {
        Object.values(rounds).forEach((value,ind) =>{
            // if(is_mobile) {
                //Do not reverse items on mobile
                Object.values(value.games.objects).sort(compareByDate).map((key, index) =>
                {
                    liveRoundsGames.push(key);
                });
        });
    }

    //get current index for
    let isRtl = (lang == 'he' || lang == 'ar');

    if(liveRoundsGames.length && currentSlideIndex == null) { //We didn't set the current Slide index yet
        if(currentGamesRounds && parseInt(currentGamesRounds)) {
            currentSlideIndex = (currentRound - 1) * numofGamesInRound;
        } else {
            currentSlideIndex = liveRoundsGames.findIndex(x => (x.status <= 2));
        }
    }

    // set current slides to display - on desktop we show full rounds, on mobile we show next games
    let currentSlides = [];

    if(is_mobile) {
        currentSlides = liveRoundsGames.length ? liveRoundsGames.splice(currentSlideIndex, itemsCount) : [];
    } else {
        currentSlideIndex = Math.floor((currentSlideIndex) / numofGamesInRound) * numofGamesInRound;
        currentRound = Math.ceil((currentSlideIndex + 1) / numofGamesInRound);

        currentSlides = liveRoundsGames.length ? liveRoundsGames.splice(Math.floor((currentSlideIndex)/numofGamesInRound) * numofGamesInRound, itemsCount) : [];
    }

    let currentRoundName = getByLang('Round', 'מחזור', 'الدورة') + " ";
    let currentRoundDate = (typeof rounds[currentRound] != 'undefined') ? rounds[currentRound].startDate : "";

    if(typeof rounds[currentRound] != 'undefined') {
        if(gamesStage == 'playoff') {
            currentRoundName = currentRoundName + parseInt((Math.ceil((currentSlideIndex + 1) / numofGamesInRound) + 26));
        } else {
            currentRoundName = currentRoundName + Math.ceil((currentSlideIndex + 1) / numofGamesInRound);
        }
    }

    let playofftextClass = "";

    if (gamesStage == 'playoff' ) {
        playofftextClass = " gamesCurrentRoundPlayoff";

        if(isRelegation) {
            currentRoundName = getByLang('Relegation ', 'פלייאוף תחתון', 'إقصاء') + " " + currentRoundName;
        } else {
            currentRoundName = getByLang('Championship ', 'פלייאוף עליון', 'بطولة') + " " + currentRoundName;
        }
    }
    // slider actions
    const slideNext = function() {
        let stage = gamesStage != 'playoff' ? "regularSeason" :  isRelegation ? "relegationRound" : "championshipRound";
        //hide next if greater than total length
        if(currentSlideIndex + itemsCount <= liveRoundsGames.length) {
            store.dispatch({stage: stage, type: "SET_CURRENT_SLIDE_INDEX", val: (currentSlideIndex + itemsCount)});
            store.dispatch({stage: stage, type: "SET_CURRENT_ROUND", val: Math.ceil((currentSlideIndex + itemsCount + 1) / numofGamesInRound) });
        }
};
    const slidePrev = function(){
        let stage = gamesStage != 'playoff' ? "regularSeason" :  isRelegation ? "relegationRound" : "championshipRound";

        // show prev if currentindex is positive
        if(currentSlideIndex > 0){
            store.dispatch({stage: stage, type: "SET_CURRENT_SLIDE_INDEX", val: (currentSlideIndex - itemsCount)});
            store.dispatch({stage: stage, type: "SET_CURRENT_ROUND", val: Math.ceil((currentSlideIndex - itemsCount +1) / numofGamesInRound)});
        }
    };

    // handle swipe events
    let touchStart,touchEnd;
    const handleTouchStart = function (e) {
        touchStart = e.targetTouches[0].clientX;
    };

    const handleTouchMove = function (e) {
        touchEnd = e.targetTouches[0].clientX;
    };
    const handleTouchEnd = function () {
        if (touchStart - touchEnd > 75) {
            isRtl?slidePrev():slideNext();
        }

        if (touchStart - touchEnd < -75) {
            isRtl?slideNext():slidePrev();
        }
    };
  return (
        <div>
            <div id="roundContainer" className="roundContainer">
                <i className={"lSNext fa "+(isRtl?'fa-angle-right':'fa-angle-left')} onClick={() => slidePrev()}></i>
                <div id={"gamesCurrentRound" + currentRound} className={"roundName " + playofftextClass}> {  currentRoundName + " | " + currentRoundDate} </div>
                <i className={"lSNext fa "+(isRtl?'fa-angle-left':'fa-angle-right')} onClick={() => slideNext()}></i>
            </div>

                <ul className={ "games-round-" + currentRound} onTouchStart={(e) => handleTouchStart(e)} onTouchMove={(e) => handleTouchMove(e)} onTouchEnd={(e) => handleTouchEnd(e)}>
                    {
                        //TODO support filtering and different look for playoffs/regular season:
                        currentSlides.map((key,index) => (
                            <GameLiveScore key={index} id={index} game={key} />
                        ))
                    }
                </ul>

        </div>
    )
};

export default liveGamesWidget
